import { render, staticRenderFns } from "./dr_search.vue?vue&type=template&id=c33ccffc&scoped=true"
import script from "./dr_search.vue?vue&type=script&lang=js"
export * from "./dr_search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33ccffc",
  null
  
)

export default component.exports